import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-loading',
  templateUrl: './login-loading.component.html',
  styleUrls: ['./login-loading.component.css']
})
export class LoginLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
